import React from 'react';
import ProductSpecifications, {
  Table as ProductSpecTable
} from '@jetshop/ui/ProductSpecifications/ProductSpecifications';
import styled from 'react-emotion';
import t from '@jetshop/intl';
import theme from '@jetshop/ui/utils/theme';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ProductDescription from './ProductDescription';

const Description = styled(ProductDescription)``;
const Content = styled('div')``;

export const SectionHeading = styled('h2')`
  font-weight: 700;
  margin-bottom: 1rem;
  text-transform: uppercase;
  font-size: 1.35rem;
  padding-bottom: 0.1875rem;
`;

export const ProductSection = styled('section')`
  width: 50%;
  flex: 0 0 auto;
  font-size: 0.875rem;
  padding: 0 2rem;

  ${ProductSpecTable} {
    th {
      white-space: nowrap;
    }
    td,
    th {
      padding: 0.3125rem;
      padding-left: 0;
      border-bottom: 1px solid #dfdfdf;
    }
  }

  ${({ theme }) => theme.below.md} {
    flex: 0 0 100%;
    padding: 0;
  }
`;

const TabListWrapper = styled('div')`
  ul.react-tabs__tab-list {
    padding: 0;

    ${theme('below.md')} {
      padding: 0;
    }

    ${theme('below.sm')} {
      padding: 0.9375rem 0;
    }

    li {
      display: inline-block;
      font-size: 14px;
      line-height: normal;
      padding: 20px 30px;
      border-right: 0.5px solid #b3b3b3;
      border-bottom: 0.5px solid #b3b3b3;
      color: rgba(0, 0, 0, 0.6);
      width: ${({ numberOfTabs }) => 100 / numberOfTabs}%;
      ${theme('below.sm')} {
        padding: 0.8125rem;
        margin: 0.3125rem 0.3125rem 0.3125rem 0rem;
      }
    }

    li:last-child {
      margin-right: 0;
      border-right: none;
    }

    li:hover {
      cursor: pointer;
    }

    li.react-tabs__tab--selected {
      border-bottom: none;
      color: black;
      font-weight: ${({ theme }) => theme.typo.fontWeightBold};

      ${theme('below.sm')} {
        background-color: #222;
        color: #fff;
        border-radius: 5px;
        border-bottom: 2px solid #ccc;
      }
    }
  }
`;

const StyledTabs = styled(Tabs)`
  margin-top: 32px;
  background-color: white;
  ${ProductSpecTable} {
    tr {
      border-bottom: 1px solid #dfdfdf;
    }
  }

  width: 100%;

  .react-tabs__tab-panel--selected {
    padding: 20px 30px 56px 30px;

    ${theme('below.sm')} {
      border: none;
    }
  }
`;

const ProductInfo = ({
  description,
  geometryTablePage,
  sizeGuidePage,
  specifications
}) => {
  const tabs = [];
  if (description) {
    tabs.push({
      tab: (
        <Tab key="product-description-title">{t('Product description')}</Tab>
      ),
      content: (
        <TabPanel key="product-description-description">
          <Description description={description} />
        </TabPanel>
      )
    });
  }

  if (specifications.length > 0) {
    tabs.push({
      tab: <Tab key="product-specification-title">{t('Specifications')}</Tab>,
      content: (
        <TabPanel key="product-specification-fields">
          <ProductSpecifications fields={specifications} />
        </TabPanel>
      )
    });
  }

  if (geometryTablePage && geometryTablePage.page) {
    tabs.push({
      tab: <Tab key="product-geometry-table">{t('Geometry table')}</Tab>,
      content: (
        <TabPanel key="product-geometry-table">
          <Content
            dangerouslySetInnerHTML={{ __html: geometryTablePage.page.content }}
          />
        </TabPanel>
      )
    });
  }

  if (sizeGuidePage && sizeGuidePage.page) {
    tabs.push({
      tab: <Tab key="product-size-guide">{t('Size guide')}</Tab>,
      content: (
        <TabPanel key="product-size-guide">
          <Content
            dangerouslySetInnerHTML={{ __html: sizeGuidePage.page.content }}
          />
        </TabPanel>
      )
    });
  }

  return (
    <TabListWrapper numberOfTabs={tabs.length}>
      <StyledTabs>
        <TabList>{tabs.map(tab => tab.tab)}</TabList>
        {tabs.map(tab => tab.content)}
      </StyledTabs>
    </TabListWrapper>
  );
};

export default ProductInfo;
